import _ from 'underscore';

/** 
 * Google Maps utility helper class
 * @class GoogleMapsUtils
 * @membeof core.helpers
 */
class GoogleMapsUtils {
  static googlePositionToCSSClass(str) {
    return str.toLowerCase().replace(/\_/, '-');
  }

  static get googleMapsPosition() {
    return {
      BOTTOM: 'BOTTOM',
      BOTTOM_CENTER: 'BOTTOM_CENTER',
      BOTTOM_LEFT: 'BOTTOM_LEFT',
      BOTTOM_RIGHT: 'BOTTOM_RIGHT',
      CENTER: 'CENTER',
      LEFT: 'LEFT',
      LEFT_BOTTOM: 'LEFT_BOTTOM',
      LEFT_CENTER: 'LEFT_CENTER',
      LEFT_TOP: 'LEFT_TOP',
      RIGHT: 'RIGHT',
      RIGHT_BOTTOM: 'RIGHT_BOTTOM',
      RIGHT_CENTER: 'RIGHT_CENTER',
      RIGHT_TOP: 'RIGHT_TOP',
      TOP: 'TOP',
      TOP_CENTER: 'TOP_CENTER',
      TOP_LEFT: 'TOP_LEFT',
      TOP_RIGHT: 'TOP_RIGHT'
    };
  }

  static get googleControls() {
    return ['mapTypeControl', 'scaleControl', 'streetViewControl', 'rotateControl',
      'fullscreenControl', 'overviewMapControl', 'panControl', 'signInControl'
    ];
  }

  static isGoogleMapsPosition(str) {
    return !_.isUndefined(this.googleMapsPosition[str]);
  }
  static getBounds(points) {
    if (_.isObject(points) &&
      points.hasOwnProperty('neLat') &&
      points.hasOwnProperty('neLng') &&
      points.hasOwnProperty('swLat') &&
      points.hasOwnProperty('swLng')) {
      return new google.maps.LatLngBounds(
        new google.maps.LatLng(+points.swLat, +points.swLng),
        new google.maps.LatLng(+points.neLat, +points.neLng));
    } else {
      return null;
    }
  }

  static getBoundsCenter(bounds) {
    if (_.isObject(bounds)) {
      return bounds.getCenter();
    } //else --> Invalid bounds argument
  }

  static setLimitsToBBox(map, bbox) {
    var C, X, Y, AmaxX, AmaxY, AminX, AminY;
    if (bbox.contains(map.getCenter())) {
      return;
    }
    // It`s not OK, so find the nearest allowed point and move there
    C = map.getCenter();
    X = C.lng();
    Y = C.lat();

    AmaxX = bbox.getNorthEast().lng();
    AmaxY = bbox.getNorthEast().lat();
    AminX = bbox.getSouthWest().lng();
    AminY = bbox.getSouthWest().lat();

    if (X < AminX) { X = AminX; }
    if (X > AmaxX) { X = AmaxX; }
    if (Y < AminY) { Y = AminY; }
    if (Y > AmaxY) { Y = AmaxY; }

    map.panTo(new google.maps.LatLng(Y, X));
  }

  static containPointInBBox(bounds, latlng) {
    return bounds.contains(latlng);
  }

  static containPointInPolygons(point, polygons) {
    return _.some(polygons, (polygon) => {
      return google.maps.geometry.poly.containsLocation(point, polygon);
    });
  }

  /**
   * @static   
   * @param {google.maps.LatLngBounds} bounds - bounding box
   * @returns GeoJSON geometry
   */
  static boundingBoxToPolygon(bounds) {
    let polygon = [];
    polygon[0] = [bounds.getNorthEast().lng(), bounds.getNorthEast().lat()];
    polygon[1] = [bounds.getSouthWest().lng(), bounds.getNorthEast().lat()];
    polygon[2] = [bounds.getSouthWest().lng(), bounds.getSouthWest().lat()];
    polygon[3] = [bounds.getNorthEast().lng(), bounds.getSouthWest().lat()];
    polygon[4] = [bounds.getNorthEast().lng(), bounds.getNorthEast().lat()];
    return { type: 'Polygon', coordinates: polygon };
  }
}

export default GoogleMapsUtils;



// WEBPACK FOOTER //
// ./lmm-widget/src/helpers/GoogleMapsUtils.js